import { useEffect, useState } from 'react';
import { handleError } from '../../../../components/errors/errorHandling';
import { getClientSecret } from '../../../../services/payment/PaymentService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const usePaymentAccounts = (_organizationId?: string, _accountId?: string) => {
  const [accountId, setAccountId] = useState(_accountId);
  const [organizationId, setOrganizationId] = useState(accountId);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [clientSecret, setClientSecret] = useState<any>();

  useEffect(() => {
    if (!accountId || !organizationId) {
      // TODO Set invalid properties
      return;
    }

    setIsLoading(true);
    loadAsync();
  }, [accountId, organizationId]);

  const loadAsync = async () => {
    try {
      if (accountId && organizationId) {
        const { data } = await getClientSecret(organizationId, accountId);
        setClientSecret(data);
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  return {
    clientSecret,
    setAccountId,
    setOrganizationId,
    isLoading,
  };
};

export default usePaymentAccounts;
